import React from 'react'
import Styled from 'styled-components'

const Container = Styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`

const Error = Styled.h3`
  font-size: 8rem;
  text-align: center;
  margin: 0 0 1rem 0;
`

const Text = Styled.p`
  text-align: center;
  margin: 0;
`

export default () => (
  <Container>
    <Error>404</Error>
    <Text>Not found</Text>
  </Container>
)



// WEBPACK FOOTER //
// ./src/components/NotFound/index.js